import axios from "axios";
import { AuthModel } from "./models";
import { sessionManager } from "../utils/sessionManager";

export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const ASSET_URL =
  "https://restechlabs-storage.s3.ap-southeast-2.amazonaws.com/";
export const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1IjoiZm9saW9tYW5hZ2VyIiwiYSI6ImNscTNqY2I5MzBlYWsyc2x4MW5nbWxodzUifQ.Pfz6iwJgGMNEETu0zBrv_A";

axios.interceptors.request.use(
  (config) => {
    if (config.authorization !== false) {
      const token = AuthModel.getToken();
      if (token) {
        config.headers.Authorization = "Bearer " + token;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors (session expired)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // If we get a 401 or 403, session has expired
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Don't trigger for login/signup/forgot-password endpoints
      const url = error.config?.url || "";
      const isAuthEndpoint = 
        url.includes("/auth/login") ||
        url.includes("/auth/signup") ||
        url.includes("/auth/reset-password") ||
        url.includes("/auth/verify-otp") ||
        url.includes("/auth/create-password");
      
      if (!isAuthEndpoint) {
        AuthModel.logout();
        sessionManager.notifySessionExpired();
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
